import { gql } from '@apollo/client';

// Query to get field metadata for a document type
export const GET_EXTRACTED_TERMS_FIELD_METADATA = gql`
  query GetExtractedTermsFieldMetadata($documentType: String!) {
    extractedTermsFieldMetadata(documentType: $documentType)
  }
`;
